import { FaBook, FaVideo, FaFeatherAlt, FaRegFileAlt } from "react-icons/fa";

const categoryLabels = {
  books: "Visit Book →",
  literature: "Read Literature →",
  videos: "Watch Video →",
};

const categoryIcons = {
  books: <FaBook className="me-2" style={{ color: "var(--bs-warning)" }} />,
  videos: <FaVideo className="me-2" style={{ color: "var(--bs-accent)" }} />,
  literature: (
    <FaFeatherAlt className="me-2" style={{ color: "var(--bs-success)" }} />
  ),
};

const ResourceCard = ({ item }) => {
  const btnText = categoryLabels[item.category] || "Visit Resource →";

  const Icon = categoryIcons[item.category] || (
    <FaRegFileAlt className="me-2" />
  );

  return (
    <div className="resource-card bg-secondary">
      <h4 className="resource-card-title d-flex align-items-center">
        {Icon}
        {item.title}
      </h4>

      <p className="resource-card-text">{item.description}</p>

      {item.links?.map((link, i) => (
        <a
          key={i}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="resource-link text-primary fw-semibold"
        >
          {btnText}
        </a>
      ))}
    </div>
  );
};

export default ResourceCard;
